import { useMemo } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import FaqSection from '@/components/feature/FaqSection';
import BackToTop from '@/components/feature/BackToTop';
import usePageMeta from '@/hooks/usePageMeta';
import { commonFaqs, siteCategories } from '@/mocks/navigation';
import Hero from './components/Hero';
import HotPicks from './components/HotPicks';
import CategoryGrid from './components/CategoryGrid';
import DirectorySection from './components/DirectorySection';
import SubmitCta from './components/SubmitCta';

export default function Home() {
  const options = useMemo(() => {
    const base = (typeof __BASE_PATH__ === 'string' ? __BASE_PATH__ : '/').replace(/\/$/, '');
    const url = `${window.location.origin}${base}/`;
    const jsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          name: '爆料导航网',
          url,
          description: '按领域整理信息站点的爆料导航分类与网站目录，一站收录。',
          inLanguage: 'zh-CN',
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: `${url}?q={search_term_string}`,
            },
            'query-input': 'required name=search_term_string',
          },
        },
        {
          '@type': 'Organization',
          name: '爆料导航网',
          url,
          email: 'contact@baoliao-nav.com',
          description: '专注分类整理信息入口的中文导航站，按十大领域归集公开资讯站点。',
        },
        {
          '@type': 'ItemList',
          name: '爆料导航分类目录',
          numberOfItems: siteCategories.length,
          itemListElement: siteCategories.map((category, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: category.name,
            url: `${url}category/${category.id}`,
          })),
        },
        {
          '@type': 'FAQPage',
          mainEntity: commonFaqs.map((faq) => ({
            '@type': 'Question',
            name: faq.q,
            acceptedAnswer: { '@type': 'Answer', text: faq.a },
          })),
        },
      ],
    };

    return {
      title: '爆料导航 - 分类整理资讯站点，爆料导航网站目录一站收录',
      description:
        '爆料导航网按领域分类整理热点资讯站点，从娱乐、财经到消费维权，爆料导航分类清晰、网站目录一站收录，打开就能顺藤摸瓜找到更多同类站点，省时省力。',
      keywords: '爆料导航,爆料导航分类,爆料导航网站目录,爆料导航大全,爆料导航资源整理',
      path: '/',
      jsonLd,
    };
  }, []);

  usePageMeta(options);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader logoAsHeading />
      <main className="flex-1">
        <Hero />
        <HotPicks />
        <CategoryGrid />
        <DirectorySection />
        <FaqSection items={commonFaqs} />
        <SubmitCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}